import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import CommonButton from '../../components/atoms/CommonButton';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import genGochiStatuses from '../../constants/GenGochiStatuses';

const styles = {
  root: {
    backgroundColor: '#fff'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  headerLabel: {
    fontWeight: '500'
  },
  overflow: {
    overflow: 'auto'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      genGochis: state.gochis.genGochis,
      totalCount: state.gochis.totalCount
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('checked', 'setChecked', () => {
    return new Map();
  }),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    genGochis,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    setRowsPerPage,
    handleChangeGenGochiStatus,
    checked,
    setChecked,
    setResultMessage,
    updateOpenProgress,
    updateLoading
  }) => {
    function uncheckAll() {
      setChecked(new Map());
    }

    function checkAll() {
      const newState = new Map(checked);
      genGochis.forEach(el => {
        newState.set(el.genGochiId, el.status);
      });
      setChecked(newState);
    }

    function handleChangeChecked(genGochi, isChecked) {
      const newState = new Map(checked);
      if (isChecked) {
        newState.set(genGochi.genGochiId, genGochi.status);
      } else newState.delete(genGochi.genGochiId);
      setChecked(newState);
    }

    function runJob() {
      const checkedGenGochis = [];
      let invalid = false;
      checked.forEach((status, genId) => {
        if (invalid) return;
        if (status === 3) {
          invalid = true;
        } else if (status === 0 || status === 2) {
          checkedGenGochis.push(genId);
        }
      });

      if (invalid) {
        updateOpenProgress(true);
        updateLoading(false);
        setResultMessage('更新に失敗しました。再確認してください。');
        return;
      }

      if (checkedGenGochis.length === 0) {
        updateOpenProgress(true);
        updateLoading(false);
        setResultMessage('データを選択してください。');
        return;
      }

      handleChangeGenGochiStatus(checkedGenGochis, 3);
      uncheckAll();
    }

    function deleteGenGochis() {
      const checkedGenGochis = [];
      checked.forEach((status, genId) => {
        if (status !== 1 && status !== 4) {
          checkedGenGochis.push(genId);
        }
      });

      if (checkedGenGochis.length === 0) {
        updateOpenProgress(true);
        updateLoading(false);
        setResultMessage('データを選択してください。');
        return;
      }

      handleChangeGenGochiStatus(checkedGenGochis, 5);
      uncheckAll();
    }

    return (
      <div className={classes.root}>
        <div>
          <div className={classes.buttonContainer}>
            <CommonButton
              className={classes.button}
              title="全て選択"
              onClickAction={checkAll}
            />
            <CommonButton
              className={classes.button}
              title="JOB機能"
              onClickAction={runJob}
            />
            <CommonButton
              className={classes.button}
              title="削除"
              secondary
              onClickAction={deleteGenGochis}
            />
          </div>
          <div className={classes.scrollTable}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>ごち入れID</TableCell>
                  <TableCell>ごちユーザータイプ</TableCell>
                  <TableCell>ごちるユーザーID</TableCell>
                  <TableCell>ごちられるユーザーID</TableCell>
                  <TableCell>メニューID</TableCell>
                  <TableCell>グループID</TableCell>
                  <TableCell>店舗ID</TableCell>
                  <TableCell>値段</TableCell>
                  <TableCell>個数</TableCell>
                  <TableCell>お客様のメールアドレス</TableCell>
                  <TableCell>お客様の名前</TableCell>
                  <TableCell>コメント</TableCell>
                  <TableCell>決済方法</TableCell>
                  <TableCell>インポート時間</TableCell>
                  <TableCell>予約実施時間</TableCell>
                  <TableCell>実際実施時間</TableCell>
                  <TableCell>ステータス</TableCell>
                  <TableCell>領収書NO</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {genGochis &&
                  genGochis.map(genGochi => (
                    <TableRow>
                      <TableCell>
                        {genGochi.status !== 1 && genGochi.status !== 4 && (
                          <Checkbox
                            color="primary"
                            checked={checked.has(genGochi.genGochiId)}
                            onChange={e =>
                              handleChangeChecked(genGochi, e.target.checked)
                            }
                          />
                        )}
                      </TableCell>
                      <TableCell>{genGochi.genGochiId}</TableCell>
                      <TableCell>{genGochi.gochiUserType}</TableCell>
                      <TableCell>{genGochi.gochiRegisterId}</TableCell>
                      <TableCell>{genGochi.gochiUserId}</TableCell>
                      <TableCell>{genGochi.menuId}</TableCell>
                      <TableCell>{genGochi.groupId}</TableCell>
                      <TableCell>{genGochi.shopId}</TableCell>
                      <TableCell>{genGochi.price}</TableCell>
                      <TableCell>{genGochi.quantity}</TableCell>
                      <TableCell>{genGochi.customerEmail}</TableCell>
                      <TableCell>{genGochi.customerName}</TableCell>
                      <TableCell>{genGochi.comment}</TableCell>
                      <TableCell>
                        {genGochi.paymentMethod === 0
                          ? 'Gigi自身'
                          : 'クレジットカード'}
                      </TableCell>
                      <TableCell>{genGochi.createdAt}</TableCell>
                      <TableCell>{genGochi.startTime}</TableCell>
                      <TableCell>{genGochi.updatedAt}</TableCell>
                      <TableCell>
                        {genGochiStatuses[genGochi.status] &&
                          genGochiStatuses[genGochi.status].name}
                      </TableCell>
                      <TableCell>{genGochi.gochiBillNo}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>

          <ExPaginationGroup
            count={
              totalCount % rowsPerPage > 0
                ? Math.floor(totalCount / rowsPerPage) + 1
                : Math.floor(totalCount / rowsPerPage)
            }
            selectedPage={page}
            handleChangePage={(e, p, limit) => handleChangePage(e, p, limit)}
            limit={rowsPerPage}
            totalCount={totalCount}
            setLimit={setRowsPerPage}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
